import { render, staticRenderFns } from "./TheSessionHistory.vue?vue&type=template&id=4b890700&scoped=true"
import script from "./TheSessionHistory.vue?vue&type=script&lang=js"
export * from "./TheSessionHistory.vue?vue&type=script&lang=js"
import style0 from "./TheSessionHistory.vue?vue&type=style&index=0&id=4b890700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b890700",
  null
  
)

export default component.exports